import styled from "styled-components/macro";
import { NavLink } from "react-router-dom";

import {
  colors,
  fontStyle,
  fontSize,
  space,
  NAVBAR_HEIGHT,
  titlefontStyle,
  breakpoint,
  transition,
  zIndex,
} from "shared/styles/constants";
import { hoverFocus } from "shared/styles/defaults";
import { motion } from "framer-motion";

export const StyledNavbar = styled.nav`
  grid-area: nav;

  display: flex;
  justify-content: space-between;

  width: 100vw;
  height: ${NAVBAR_HEIGHT}px;

  padding: 0 ${space.m};
  border-bottom: 1px solid ${colors.black};

  color: ${colors.white};

  a {
    text-decoration: none;
  }

  ${breakpoint("m", "up")} {
    padding: 0 ${space.l};
  }
`;

export const NavMainLink = styled(NavLink)`
  display: flex;
  align-items: center;

  ${hoverFocus.defaultFocus}

  ${titlefontStyle.bold};
  ${fontSize.xxl};

  ${breakpoint("m", "up")} {
    ${fontSize.xxxl};
  }

  svg {
    width: 32px;
    height: 32px;

    margin-right: ${space.s};

    color: currentColor;

    ${breakpoint("m", "up")} {
      width: 50px;
      height: 50px;

      margin-right: ${space.m};
    }
  }

  span {
    transform: translateY(-3px); // visaully align center, yay font
  }
`;

export const NavTitle = styled.span`
  ${fontStyle.bold}
`;

export const StyledNavLink = styled(NavLink)`
  position: relative;

  display: flex;
  align-items: center;

  padding: ${space.xs} ${space.xl};

  color: ${colors.grey4};

  transition: color ${transition.default};

  ${breakpoint("m", "up")} {
    padding: ${space.xs};
  }

  &::after {
    content: "";

    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;

    width: 4px;

    background-color: ${colors.green};

    opacity: 0;

    transition: opacity ${transition.default};

    ${breakpoint("m", "up")} {
      left: 0;
      right: 0;
      top: auto;
      bottom: 0;

      width: auto;
      height: 4px;
    }
  }

  &.active {
    color: inherit;

    &::after {
      opacity: 1;
    }
  }
`;

export const LeftContent = styled.div`
  display: flex;

  > * + * {
    margin-left: ${space.s};

    ${breakpoint("m", "up")} {
      margin-left: ${space.l};
    }
  }
`;

export const UserInitials = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  height: 30px;
  width: 30px;

  border-radius: 50%;
  margin-right: ${space.xs};

  background-color: ${colors.grey1};

  ${fontSize.l}
  ${titlefontStyle.bold}
  text-transform: lowercase;

  span {
    transform: translateY(-2px); // visaully align center, yay font
  }
`;

export const CurrentUserContent = styled(NavLink)`
  display: flex;
  align-items: center;

  padding: 0 ${space.xl};

  ${breakpoint("m", "up")} {
    padding: 0;
  }
`;

export const MobileMenu = styled(motion.div)`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: ${zIndex.dropdown};

  padding: ${space.xl} 0;

  background-color: ${colors.black};

  > * + * {
    margin-top: ${space.l};
  }
`;

export const MobileCloseButton = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  z-index: ${zIndex.above};

  display: flex;
  align-items: center;
  justify-content: flex-end;

  height: ${NAVBAR_HEIGHT}px;

  padding: 0 ${space.m};
`;
